<template lang="pug">
.v-table.table(v-if="data" :id="data?.id")
	.table__body(v-if="data.items")
		.table__tr(v-for="tr in data.items")
			.table__td(v-for="td in tr.items" v-html="td.text")
	.table__actions(v-if="data.actions")
		a.btn.btn--primary.table__action(v-for="action in data.actions" :href="action.link") {{action.text}}
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";

export default {
	mixins: [
		sourceMixin
	],

	props: {
		propsData: {
			type: Object,
			default: null
		}
	},

	watch: {
		propsData(state) {
			this.data = state
		}
	},

	mounted() {
		if (this.propsData) {
			this.data = this.propsData;
		}
	},

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>